import React from "react";
import styling from "./Button.module.css";

export default function Button({ title }) {
  return <div className={styling.Button}>{title}</div>;
}
